import { Box, Group, Radio } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { useTranslation } from "react-i18next";

import InputLabel from "components/input/label";

interface YesNoRadioButtonProps<T> {
  name: string;
  label: string;
  form?: UseFormReturnType<T>;
  disabled?: boolean;
  required?: boolean;
  checked?: boolean;
  onChange?: (value: boolean) => void;
}

const YesNoRadioButton = <T,>(props: YesNoRadioButtonProps<T>) => {
  const { form, name, label, disabled, checked, onChange } = props;
  const { t } = useTranslation();

  const getChecked = (val: boolean) =>
    checked === val || form?.getInputProps(name).defaultValue === val;

  return (
    <Box>
      <InputLabel label={label} required={props.required} />
      <Group mt={"xs"}>
        <Radio
          checked={getChecked(true)}
          onChange={() => {
            form?.setFieldValue(name, true as any);
            onChange?.(true);
          }}
          label={t("yes")}
          disabled={disabled}
        />
        <Radio
          checked={getChecked(false)}
          onChange={() => {
            form?.setFieldValue(name, false as any);
            onChange?.(false);
          }}
          label={t("no")}
          disabled={disabled}
        />
      </Group>
    </Box>
  );
};

export default YesNoRadioButton;
